import React from "react"

const MError = ({
  status,
  headline,
  children,
  buttonLabel,
  buttonLink,
  onButtonClick,
}) => {

  const ButtonTag = buttonLink ? "a" : "button"

  return (
    <section className="m-Error">
      <div className="m-Error-wrapper">
        <div className="m-Error-container">
          <div className="m-Error-content">
            <h2 className="dfb-Headline dfb-Headline--h2 m-Error-errorCode">
              {status}
            </h2>
            <h3 className="dfb-Headline dfb-Headline--h3 m-Error-text">
              {headline}
            </h3>

            {children}

            <ButtonTag className="dfb-Button m-Error-button" href={buttonLink} onClick={onButtonClick}>
              <span className="dfb-Button-label">{buttonLabel}</span>
            </ButtonTag>

          </div>
        </div>
      </div>
      <div className="m-Error-playground" />
    </section>
  )
}

export default MError
